function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.CKEditor = e() : t.CKEditor = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 2);
  }([function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == _typeof(t) && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(1));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    n.r(e);

    var i = function i(t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    },
        r = n(0),
        o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        a = r.a || o || Function("return this")(),
        u = function u() {
      return a.Date.now();
    },
        c = a.Symbol,
        s = Object.prototype,
        f = s.hasOwnProperty,
        l = s.toString,
        d = c ? c.toStringTag : void 0;

    var p = function p(t) {
      var e = f.call(t, d),
          n = t[d];

      try {
        t[d] = void 0;
        var i = !0;
      } catch (t) {}

      var r = l.call(t);
      return i && (e ? t[d] = n : delete t[d]), r;
    },
        v = Object.prototype.toString;

    var y = function y(t) {
      return v.call(t);
    },
        b = c ? c.toStringTag : void 0;

    var h = function h(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : b && b in Object(t) ? p(t) : y(t);
    };

    var m = function m(t) {
      return null != t && "object" == _typeof(t);
    };

    var g = function g(t) {
      return "symbol" == _typeof(t) || m(t) && "[object Symbol]" == h(t);
    },
        j = /^\s+|\s+$/g,
        $ = /^[-+]0x[0-9a-f]+$/i,
        O = /^0b[01]+$/i,
        _ = /^0o[0-7]+$/i,
        w = parseInt;

    var x = function x(t) {
      if ("number" == typeof t) return t;
      if (g(t)) return NaN;

      if (i(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = i(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(j, "");
      var n = O.test(t);
      return n || _.test(t) ? w(t.slice(2), n ? 2 : 8) : $.test(t) ? NaN : +t;
    },
        S = Math.max,
        E = Math.min;

    var T = function T(t, e, n) {
      var r,
          o,
          a,
          c,
          s,
          f,
          l = 0,
          d = !1,
          p = !1,
          v = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");

      function y(e) {
        var n = r,
            i = o;
        return r = o = void 0, l = e, c = t.apply(i, n);
      }

      function b(t) {
        return l = t, s = setTimeout(m, e), d ? y(t) : c;
      }

      function h(t) {
        var n = t - f;
        return void 0 === f || n >= e || n < 0 || p && t - l >= a;
      }

      function m() {
        var t = u();
        if (h(t)) return g(t);
        s = setTimeout(m, function (t) {
          var n = e - (t - f);
          return p ? E(n, a - (t - l)) : n;
        }(t));
      }

      function g(t) {
        return s = void 0, v && r ? y(t) : (r = o = void 0, c);
      }

      function j() {
        var t = u(),
            n = h(t);

        if (r = arguments, o = this, f = t, n) {
          if (void 0 === s) return b(f);
          if (p) return clearTimeout(s), s = setTimeout(m, e), y(f);
        }

        return void 0 === s && (s = setTimeout(m, e)), c;
      }

      return e = x(e) || 0, i(n) && (d = !!n.leading, a = (p = "maxWait" in n) ? S(x(n.maxWait) || 0, e) : a, v = "trailing" in n ? !!n.trailing : v), j.cancel = function () {
        void 0 !== s && clearTimeout(s), l = 0, r = f = o = s = void 0;
      }, j.flush = function () {
        return void 0 === s ? c : g(u());
      }, j;
    };

    var D = {
      name: "ckeditor",
      render: function render(t) {
        return t(this.tagName);
      },
      props: {
        editor: {
          type: Function,
          "default": null
        },
        value: {
          type: String,
          "default": ""
        },
        config: {
          type: Object,
          "default": function _default() {
            return {};
          }
        },
        tagName: {
          type: String,
          "default": "div"
        },
        disabled: {
          type: Boolean,
          "default": !1
        }
      },
      data: function data() {
        return {
          $_instance: null,
          $_lastEditorData: {
            type: String,
            "default": ""
          }
        };
      },
      mounted: function mounted() {
        var _this = this;

        var t = Object.assign({}, this.config);
        this.value && (t.initialData = this.value), this.editor.create(this.$el, t).then(function (t) {
          _this.$_instance = t, t.isReadOnly = _this.disabled, _this.$_setUpEditorEvents(), _this.$emit("ready", t);
        })["catch"](function (t) {
          console.error(t);
        });
      },
      beforeDestroy: function beforeDestroy() {
        this.$_instance && (this.$_instance.destroy(), this.$_instance = null), this.$emit("destroy", this.$_instance);
      },
      watch: {
        value: function value(t, e) {
          t !== e && t !== this.$_lastEditorData && this.$_instance.setData(t);
        },
        disabled: function disabled(t) {
          this.$_instance.isReadOnly = t;
        }
      },
      methods: {
        $_setUpEditorEvents: function $_setUpEditorEvents() {
          var _this2 = this;

          var t = this.$_instance,
              e = T(function (e) {
            var n = _this2.$_lastEditorData = t.getData();

            _this2.$emit("input", n, e, t);
          }, 300, {
            leading: !0
          });
          t.model.document.on("change:data", e), t.editing.view.document.on("focus", function (e) {
            _this2.$emit("focus", e, t);
          }), t.editing.view.document.on("blur", function (e) {
            _this2.$emit("blur", e, t);
          });
        }
      }
    };
    var N = {
      install: function install(t) {
        t.component("ckeditor", D);
      },
      component: D
    };
    e["default"] = N;
  }])["default"];
});